import { ACTIONS } from "./ACTIONS";
import appInitialState from "./appInitialState";

const appReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_IS_APP_LOADING:
      return {
        ...state,
        isAppLoading: action.isAppLoading
      };
    case ACTIONS.SET_IS_CALLING_API:
      return {
        ...state,
        isCallingApi: action.isCallingApi
      };
    case ACTIONS.TOGGLE_INFO_MODAL:
      return {
        ...state,
        isInfoModalOpen: !state.isInfoModalOpen
      };
    case ACTIONS.SET_PROGRESS_ALERT:
      return {
        ...state,
        progressAlert: action.progressAlert,
        showProgressAlert: true
      };
    case ACTIONS.RESET_PROGRESS_ALERT:
      return {
        ...state,
        progressAlert: {
          variant: null,
          message: null
        },
        showProgressAlert: false
      };
    case ACTIONS.SHOW_CREATED_COURSE_MODAL:
      return {
        ...state,
        isAppLoading: false,
        isInfoModalOpen: false,
        showProgressAlert: false,
        isCreatedCourseModalOpen: true,
        createdCourse: action.createdCourse
      };
    case ACTIONS.CLOSE_APP_REDIRECT:
      return {
        ...appInitialState
      };
    case ACTIONS.BACK_TO_FORM:
      return {
        ...appInitialState,
        isAppLoading: false
      };
    case ACTIONS.SET_COURSES:
      return {
        ...state,
        courses: action.courses
      };
    default:
      return { ...state };
  }
};

export default appReducer;
